import { NavMarker } from 'react-rhumb';
import { useHistory } from 'quartz-routing/react-router';
import UsageTracker from '../../utils/UsageTracker';
import { SCREENS } from '../../constants/Tracking';
// @ts-expect-error Could not find a declaration file for module
import TrackDeprecatedModal from '../../components/Modals/FeatureIntroModals/TrackDeprecatedModal';
import { isTrackDeprecated } from '../../utils/utils';
import { useCallback, useEffect } from 'react';
import { getFirstContentForTrackUrl } from '../../features/tracks/tracksRouting';
import StoredContentContainer from '../StoredContentContainer';
import TrackIntroductionInformation from '../../components/TrackPage/TrackIntroductionInformation';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const TrackIntroPageContainer = ({
  track
}) => {
  const {
    id: trackId,
    introVideo,
    deprecationCta,
    deprecationMessage,
    deprecationFinalDate,
    deprecated
  } = track;
  const history = useHistory();
  const firstContentUrl = getFirstContentForTrackUrl(track);
  const redirectToFirstContentIfNoIntro = useCallback(() => {
    if (!introVideo) {
      history.replace(firstContentUrl);
    }
  }, [introVideo, firstContentUrl, history]);
  useEffect(() => {
    redirectToFirstContentIfNoIntro();
    UsageTracker.track('subpageView', {
      screen: SCREENS.TRACK,
      subscreen: 'intro',
      trackId
    });
  }, [redirectToFirstContentIfNoIntro, trackId]);
  const isDeprecated = isTrackDeprecated(deprecated, deprecationFinalDate);
  return /*#__PURE__*/_jsxs(NavMarker, {
    name: "COURSE_INTRO_VIEW_LOADED",
    children: [introVideo && /*#__PURE__*/_jsxs("div", {
      children: [/*#__PURE__*/_jsx(StoredContentContainer, {
        content: introVideo,
        track: track
      }), /*#__PURE__*/_jsx(TrackIntroductionInformation, {
        track: track
      })]
    }), isDeprecated && /*#__PURE__*/_jsx(TrackDeprecatedModal, {
      cta: deprecationCta,
      message: deprecationMessage,
      trackId: trackId
    })]
  });
};
export default TrackIntroPageContainer;